import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { TranslateModule } from '@ngx-translate/core';

// PRIMENG

import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { InputTextModule } from 'primeng/inputtext';
import { CaptchaModule } from 'primeng/captcha';
import { ToastModule } from 'primeng/toast';

@NgModule({
    declarations: [HomeComponent],
    imports: [FormsModule, TranslateModule, CommonModule, CheckboxModule, ButtonModule, PasswordModule, InputTextModule, CaptchaModule, ToastModule],
})
export class ProjectModule { }
